var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoramLogoExportWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 174,
    viewBox: "0 0 486 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.96 93.2139V93.9141L56.3597 93.2139H55.96Z",
    fill: "#121212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0621 58.6037L67.5172 73.6119L55.9633 93.9146V93.8431L45.4088 76.1484L0 0H22.4581C22.4581 0 38.1703 0.535879 45.9978 9.90304C46.2762 10.2353 46.5439 10.5818 46.8044 10.9391L75.2447 57.2783L75.9265 58.3894L76.055 58.6001L76.0621 58.6037Z",
    fill: "url(#paint0_linear_9597_19417)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0622 58.6029L74.5203 61.3108L67.5173 73.6111L57.9016 90.502L55.9598 93.9101V93.8387L51.8908 87.0152L49.121 82.3709L45.4054 76.1404L28.8723 48.4176C29.1721 46.1991 36.7141 36.4711 42.7106 36.4711L49.0461 34.6455C52.8296 34.6455 59.3364 36.6997 63.8909 38.7789L75.2413 57.2739L75.923 58.3849L76.0515 58.5957L76.0622 58.6029Z",
    fill: "url(#paint1_linear_9597_19417)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3033 93.2139V168.058C97.0785 170.209 95.8256 173.999 89.8006 173.999H63.4841C57.2699 173.999 56.1313 169.973 55.96 167.865V162.31L61.3639 124.684L67.1034 93.2139H97.3033Z",
    fill: "url(#paint2_linear_9597_19417)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3033 92.7324V168.059C97.0785 170.21 95.8256 174 89.8006 174H63.4841C57.2699 174 56.1313 169.974 55.96 167.866V162.311L67.1034 143.58L76.5906 127.636C78.1968 124.578 79.9922 121.598 81.8268 118.565C81.8982 118.447 81.9696 118.333 82.0409 118.215C82.1587 118.022 82.273 117.833 82.3872 117.64C82.7655 117.018 83.1439 116.393 83.5222 115.764L87.5234 109.102L96.9357 93.1933L97.3033 92.736V92.7324Z",
    fill: "url(#paint3_linear_9597_19417)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.06 0L101.379 86.0336L97.1855 93.0179L97.0677 93.2144L87.527 109.098L83.5258 115.761C83.1474 116.389 82.7691 117.015 82.3907 117.636C82.2765 117.829 82.1587 118.022 82.0445 118.211C81.9731 118.329 81.9017 118.447 81.8303 118.565C79.9921 121.598 78.1968 124.578 76.5941 127.636L55.9671 162.311L55.785 93.5323L67.3568 73.3547V73.3475H67.3639L75.9374 58.3965C76.1016 58.1107 102.24 12.5289 102.24 12.5289C102.24 12.5217 102.247 12.5181 102.25 12.5146C109.089 0.632337 127.607 0 127.607 0H153.06Z",
    fill: "url(#paint4_linear_9597_19417)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9597_19417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.957 116.281C248.814 115.991 256.601 116.84 263.187 121.502C275.501 130.221 275.161 150.542 267.054 161.884C263.404 166.984 258.138 170.704 252.109 172.439C250.11 173.001 247.698 173.341 245.619 173.682C238.597 174.546 229.009 172.673 223.285 168.451C211.044 159.424 211.211 138.933 219.491 127.351C224.901 119.784 232.234 117.509 240.957 116.281ZM244.607 159.654C249.605 158.511 251.243 155.081 251.727 150.239C252.443 143.079 252.959 129.238 242.18 130.377C240.262 130.67 238.101 131.334 237.032 133.08C234.134 137.817 234.158 144.994 234.954 150.343C235.78 155.896 238.488 160.038 244.607 159.654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.119 116.253C284.235 116.157 289.731 116.189 294.88 116.216C301.967 116.355 308.521 115.642 315.486 117.444C326.652 120.332 332.545 131.155 329.875 142.173C328.749 146.818 325.426 151.682 321.191 154.066C323.001 156.961 332.488 171.494 333.006 173.616L332.882 173.793C332.05 173.489 327.853 173.706 326.706 173.73C324.381 173.744 313.052 173.954 311.569 173.531C310.672 172.921 305.535 161.011 304.687 159.038C303.206 158.935 301.284 159.023 299.686 158.966C299.663 163.254 299.891 169.636 299.526 173.752C295.08 173.507 289.826 173.878 285.295 173.744C283.532 173.693 281.057 173.857 279.357 173.596C278.82 171.903 279.031 162.588 279.061 160.388C279.26 145.716 278.772 130.91 279.119 116.253ZM299.669 144.714C302.578 144.821 304.686 144.303 307.117 142.713C308.553 141.24 308.99 139.359 308.955 137.387C308.849 131.183 303.477 131.676 299.663 130.525C299.765 134.259 299.886 141.056 299.669 144.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.471 116.243C363.058 116.099 367.28 116.231 370.918 116.212C373.942 116.197 378.234 116.11 381.167 116.32C385.645 128.93 390.035 141.57 394.341 154.24L398.403 165.952C399.036 167.772 400.58 171.93 400.781 173.585C398.808 173.927 392.856 173.675 390.56 173.754C387.512 173.847 384.369 173.665 381.332 173.835C378.253 174.007 377.658 167.517 377.034 164.94C376.243 164.732 373.607 164.747 372.7 164.748L363.725 164.791C362.177 164.803 359.459 164.923 358.042 164.677C356.904 167.375 356.034 171.337 354.649 173.83C352.795 173.691 337.537 173.497 336.372 173.818C336.328 173.83 336.285 173.844 336.241 173.857L336.09 173.596C336.013 172.173 342.223 157.64 343.271 155.106L352.254 133.15L356.253 123.342C356.998 121.506 358.42 117.681 359.471 116.243ZM368.086 149.803C369.691 149.815 371.377 149.802 372.976 149.855C372.061 147.646 371.659 145.054 370.914 142.853C370.491 141.603 369.21 135.273 368.446 134.828C366.538 138.995 365.065 145.265 363.017 149.862C364.706 149.802 366.397 149.783 368.086 149.803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.736 71.4873C477.976 73.2348 482.015 76.9792 483.405 79.3122C481.884 81.9523 478.465 84.9523 476.166 87.1539C475.236 87.4103 470.031 82.1084 469.181 81.1853C467.988 82.6332 464.883 85.776 463.476 86.8182C462.034 87.8853 455.911 80.6084 455.294 79.4104C456.607 77.2514 460.488 73.097 462.633 71.6776C463.662 71.5546 468.448 76.6714 469.38 77.6225C471.477 75.3167 473.247 73.3824 475.736 71.4873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.659 36.8831C243.167 36.3753 255.375 34.1273 256.891 34.1662C257.179 34.3725 257.377 34.6255 257.461 34.9706C258.397 38.829 258.799 43.6266 260.725 47.119C263.023 51.2867 270.209 50.6124 274.297 50.6109L283.991 50.6078L321.164 50.599L415.991 50.6015C431.894 50.6029 447.796 50.6216 463.699 50.598C464.772 50.6172 470.012 50.4401 469.992 48.8055C469.932 44.4001 469.012 39.1281 468.466 34.732C468.284 33.2749 467.704 31.0301 467.948 29.911C468.905 29.0407 480.988 27.2747 483.005 27.0254C483.005 28.3049 483.859 32.4634 484.111 34.0233C484.318 35.3028 484.789 40.037 485.06 40.866V48.8553C484.908 49.2233 484.782 49.7876 484.719 50.1745C483.003 60.594 475.197 67.9579 464.475 67.9973C462.665 68.0039 460.733 68.0311 458.889 68.0316L444.731 68.0269L393.533 68.0262L309.049 68.0245L282.373 68.0279C277.589 68.0337 272.651 68.1378 267.88 67.9521C265.271 67.8506 261.56 66.1978 259.448 64.6762C258.348 69.8012 255.186 75.9214 251.372 79.5652C247.002 83.7394 241.874 85.8321 235.825 85.67C234.06 85.6228 229.745 85.3699 228.503 83.9723C228.01 83.4175 227.186 69.2826 227.297 67.4252C230.659 68.435 235.815 68.802 239.108 67.3868C241.95 66.1608 244.18 63.8454 245.296 60.961C246.05 59.1009 246.387 57.0987 246.285 55.0946C246.09 51.7981 243.75 45.3939 242.969 41.8497C242.738 40.8008 242.032 37.7398 241.659 36.8831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.29 116.256C462.405 115.815 470.353 116.41 477.532 116.287C478.13 116.277 478.324 116.567 478.42 117.127C479.285 122.161 479.717 127.341 480.279 132.431L481.809 145.262C482.804 154.15 483.888 163.062 484.786 171.959C484.799 172.108 484.966 172.345 485.06 172.458V174H463.685C462.107 171.164 462.095 158.112 460.915 154.309C460.459 152.842 460.954 149.073 459.816 147.649L459.614 147.665C458.746 148.699 458.294 150.97 457.829 152.286C456.69 155.518 450.938 172.552 449.808 173.889C449.778 173.927 449.745 173.962 449.713 174H449.546C447.937 173.252 437.923 174.168 435.479 173.707C434.894 173.597 434.816 173.57 434.472 173.035C433.53 171.56 432.984 168.638 432.429 167.191C431.196 163.963 426.949 148.878 425.686 147.117L425.636 147.05C425.162 148.757 424.793 153.462 424.556 155.487C424.114 159.277 423.674 163.142 423.134 166.94C422.881 168.727 422.733 172.187 422.058 173.668C421.611 173.859 405.871 173.763 403.905 173.706L403.747 173.492C403.342 170.994 405.582 157.244 406.011 154.093C407.642 141.472 409.397 128.868 411.276 116.282C417.032 116.01 423.032 116.325 428.813 116.211C431.281 116.162 434.191 116.122 436.617 116.323C437.898 119.175 444.876 139.961 445.747 140.36C447.038 139.529 453.416 119.414 455.203 116.399L455.29 116.256Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.653 116.306C200.821 116.057 205.788 116.207 209.066 116.213C211.855 116.219 216.77 116.08 219.439 116.318C216.776 120.351 196.092 153.525 195.754 155.1C195.411 156.701 195.555 158.533 195.56 160.165C195.573 164.379 195.944 169.689 195.437 173.759C189.507 173.472 183.321 173.915 177.367 173.759C176.642 173.74 176.004 173.768 175.27 173.693C174.417 172.267 174.813 161.712 174.833 159.508C174.846 158.088 175.06 156.361 174.706 154.986C174.436 153.936 153.915 117.569 153.06 116.727V116.258L169.076 116.212C170.908 116.212 175.529 116.117 177.067 116.344C180.606 123.479 183.433 131.627 186.8 138.893C188.122 134.855 191.9 128.35 193.727 124.296C194.57 122.424 196.66 117.89 197.653 116.306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.811 52.297C166.985 50.8201 167.43 49.5244 167.73 48.104C168.91 42.5228 171.788 36.1589 176.403 32.5411C179.348 30.2393 183.09 29.206 186.8 29.6704C191.572 30.2602 195.142 32.9426 198.027 36.6824C201.592 41.3036 203.773 48.3146 202.988 54.1366C202.395 58.5274 199.443 63.1695 195.938 65.8315C194.786 66.7057 193.337 67.5645 191.905 67.8371C188.823 68.424 169.668 67.0208 169.358 69.6707C169.05 72.3102 170.117 77.3651 170.503 80.1591C171.161 84.9147 171.786 89.708 172.233 94.4879C166.735 94.5776 161.288 94.5124 155.794 94.5285C155.748 92.4339 155.278 89.4049 155.03 87.2572C154.504 82.3355 153.847 77.4286 153.06 72.542V65.9654L153.122 65.85C153.688 64.7842 154.002 63.1176 154.536 61.9482C156.695 57.2152 159.977 54.4275 164.869 52.8465C165.509 52.6375 166.157 52.4544 166.811 52.297ZM174.175 51.3873C177.721 51.0975 180.198 50.9494 183.759 50.9703C185.898 50.9674 188.166 51.0032 190.294 50.9545C186.907 47.4833 185.615 45.9241 180.339 46.2791C178.164 46.58 177.011 47.093 175.596 48.9518C175.027 49.7045 174.55 50.522 174.175 51.3873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.269 0H223.438C224.043 1.00781 223.826 7.23408 223.827 8.91098L223.826 23.4742L223.825 67.9988L208.369 68.0411C208.486 65.8833 208.394 62.7883 208.393 60.5778L208.391 46.2514L208.411 0.987657C208.901 1.00778 210.723 0.927993 211.19 0.858461C212.929 0.599427 222.499 0.488624 223.269 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.443 0H479.244C480.564 0.649341 482.405 1.68821 482.891 3.13154C487.298 16.1954 474.395 17.6722 465.954 17.6637C466.08 16.4672 465.633 13.5266 465.6 11.8383C468.42 11.9776 471.235 11.5678 474.14 11.5668C473.263 10.8394 472.473 10.259 472.113 9.14243C470.689 4.73095 473.691 1.46054 477.443 0ZM478.896 8.6589L479.318 8.72557C479.804 7.88964 478.887 6.62177 478.134 6.19802C477.527 5.8568 476.942 5.89631 476.273 5.9641C475.533 6.27542 475.581 6.12973 475.161 6.69584C475.397 7.85741 477.833 8.38519 478.896 8.6589Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9597_19417",
    x1: 19.4706,
    y1: -9.36359,
    x2: 66.6616,
    y2: 88.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D946EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D927EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D427EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#C829ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#B32DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9532E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7638E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9597_19417",
    x1: 29.6576,
    y1: 46.5242,
    x2: 68.4984,
    y2: 71.9107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7538E2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5930BD",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#392793",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2483",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9597_19417",
    x1: 60.0575,
    y1: 96.6006,
    x2: 96.3283,
    y2: 172.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31237D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#312393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3123B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#3123D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#3123E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3123E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9597_19417",
    x1: 108.304,
    y1: 150.286,
    x2: 74.2338,
    y2: 130.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2F2583",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2E2483",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2D2483",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D2483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9597_19417",
    x1: 110.171,
    y1: -4.79433,
    x2: 91.0588,
    y2: 166.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67E4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6CBAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#7097F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#737BF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7668F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#775CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7859EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#794DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#7B3EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#7C3AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#6D35D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#47299E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31237D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9597_19417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 332,
    height: 174,
    fill: "white",
    transform: "translate(153.06)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoramLogoExportWhite);
export default __webpack_public_path__ + "static/media/yoram-logo-export-white.a1dc35cc87ccf5feac2a348827718b7c.svg";
export { ForwardRef as ReactComponent };